export const timeoutWithDefaultValue = <T>(
  promise: Promise<T>,
  defaultValue: T,
  timeoutInMs: number,
) => {
  // create a promise that after a specified time will return the defualt value
  const timeout = new Promise<T>((resolve) => {
    setTimeout(() => {
      resolve(defaultValue);
    }, timeoutInMs);
  });

  // returns a race between timeout and the passed promise
  return Promise.race([promise, timeout]);
};
